module.exports = __webpack_public_path__ + "static/media/arrow_back_24_px.142f63c2.svg";